export default __webpack_public_path__ + "static/media/dp-tdd-js.6483515b.png";